import { IApiService } from '../interfaces/services/IApiService';
import { ApiRequestConfig, apiService } from './api.service';

import {
	ISubscription,
	SubscriberPlanEnum,
} from '@/interfaces/entities/subscription.';
import { ISubscriptionService } from '@/interfaces/services/ISubscriptionService';

class SubscriptionService implements ISubscriptionService {
	api: IApiService<ApiRequestConfig>;

	constructor(api: IApiService<ApiRequestConfig>) {
		this.api = api;
	}

	async giveSubscription(
		userId: number,
		subscriptionPlan: SubscriberPlanEnum,
		config?: ApiRequestConfig,
	): Promise<ISubscription> {
		return await this.api.put(
			`/subscription/free/${userId}`,
			{ subscriptionPlan },
			config,
		);
	}

	async cancelSubscription(
		userId: number,
		config?: ApiRequestConfig,
	): Promise<ISubscription> {
		return await this.api.delete(`/subscription/free/${userId}`, config);
	}
}

export const subscriptionService = new SubscriptionService(apiService);
